import React, { useEffect } from 'react';
import useAudioTest from '../hooks/useAudioTest';
import { Buttons, Card } from 'components/Card/Card';
import { cdn } from 'core/cdn';
import { Button } from 'components/Button';
import { languages } from 'locales/languages';

const numberOfSoundBars = 15;

const getVolumeLevelPercent = (volumeLevel: number) => {
  let volume = volumeLevel;
  if(volumeLevel > 100) {
    volume = 100;
  }
  if(volumeLevel < 0) {
    volume = 0;
  }
  return Math.round((volume / 100)*numberOfSoundBars)
}

const AudioTest = ({onAccept, onError}) => {
  const {
    error,
    isAudioInputTestRunning,
    readAudioInput,
    stopAudioTest,
    inputLevel,
  } = useAudioTest();
  const volumeLevel = inputLevel;

  useEffect(() => {
    if (!error && !isAudioInputTestRunning) {
      readAudioInput({ deviceId: 'default'});
    }
    if(error) {
      stopAudioTest();
    }
  }, [
    error,
    isAudioInputTestRunning,
    stopAudioTest,
    readAudioInput,
  ])
  return <Card title={languages.putYourHeadsetAndSpeak}>
    <div className='flex-center' style={{ flexDirection: 'column' }}>
      <img src={cdn('/images/devices/diagnostic/mic_and_headset.svg')} alt="casque" width={"150px"}/>
      <br />
      <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>
        { Array(getVolumeLevelPercent(volumeLevel)).fill('').map(() => <img height={"55px"} src={cdn('/images/devices/diagnostic/volume_line_full.svg')} alt="full volume bar" />)}
        { Array(numberOfSoundBars - (getVolumeLevelPercent(volumeLevel))).fill('').map(() => <img height={"55px"} src={cdn("/images/devices/diagnostic/volume_line_empty.svg")} alt="empty volume bar" />)}
      </div>
    </div>
    <Buttons>
      <Button type="default" style={{ width: '350px' }} onClick={() => {
        console.error(`user raised an error ${error}`, {
          route: 'device:AudioTest',
        })
        onError(error)
        }}>
        {languages.no}
      </Button>
      <Button type="primary" style={{ width: '350px' }} onClick={() => onAccept()}>
        {languages.yes}
      </Button>
    </Buttons>
  </Card>
}

export default AudioTest;